import { useClientQueries } from '@zenstackhq/tanstack-query/react';
import { schema } from '../__generated__/schema-lite';

export type AgentCallRow = {
  id: string;
  startedAt: string | null;
  endedAt: string | null;
  durationSec: number;
  cost: number;
  status: string | null;
  endedReason: string | null;
  summary: string | null;
  transcript: string | null;
  callerName: string | null;
  callerPhone: string | null;
};
export type AgentCallsData = {
  calls: AgentCallRow[];
  totalCalls: number;
  totalDurationSec: number;
  totalCost: number;
};

/** Recent calls + totals for one ElevenLabs agent (admin dashboard split panel). */
export function useAgentCalls(externalAgentId: string) {
  const crud = useClientQueries(schema);
  const q = crud.$procs.agentCalls.useQuery(
    { args: { input: { externalAgentId } } },
    { staleTime: 30_000, retry: false },
  );
  return {
    data: q.data as AgentCallsData | undefined,
    isError: q.isError,
    error: q.error,
  };
}
